import angular from 'angular';
import keyCodes from '../keycodes/keycodes';

export default angular
  .module('csm.util.spaceClick', [keyCodes])

  /*******************************************************************************
   * Directive: spaceClick
   *
   * @ngdoc     directive
   * @name      spaceClick
   * @memberof  csm.util.spaceClick
   * @restrict  attribute
   *
   * @description
   * This directive allows the user to "click" on an active element by using the
   * spacebar.
   *******************************************************************************/
  /* @ngInject */
  .directive('spaceClick', function ($timeout, KEYCODES) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        /*************************************************************************
         * keyListener */
        /**
         * Key press listener for the space bar. When triggered by the space bar,
         * the click listeners will be triggered on the element.
         *
         * A delay was found to be needed when using this with confirm alert dialogs.
         *************************************************************************/
        function keyListener(event) {
          var code = event.charCode || event.keyCode;
          if (code == KEYCODES.SPACE) {
            event.preventDefault();
            $timeout(function () {
              element[0].click();
            }, 150);
          }
        }

        /*--------------------------------------*/
        /* Add a key listener for the space bar */
        /*--------------------------------------*/
        element.on('keypress', keyListener);

        /*-------------------*/
        /* Cleanup the scope */
        /*-------------------*/
        scope.$on('$destroy', function () {
          element.off('keypress', keyListener);
        });
      }
    };
  }).name;
